<div class="ta-section">
  <app-side-nav *ngIf="isLoggedIn" class="side-nav"></app-side-nav>
  <div class="main" [ngClass]="{'loggedInStyle':isLoggedIn}">
    <app-header *ngIf="isLoggedIn" class="header"></app-header>
    <div class="main-section">
      <toast #toastRef></toast>
      <router-outlet></router-outlet>
      <notifications *ngIf="isLoggedIn"></notifications>
      <ng-http-loader [entryComponent]="LoaderComponent" [backdrop]="true" [debounceDelay]="100" [extraDuration]="0"
        [minDuration]="300" [opacity]=".4" [backdropBackgroundColor]="'#777777'" [filteredUrlPatterns]="LoaderExcludes">
      </ng-http-loader>
      <app-footer *ngIf="excludeUrl()" ></app-footer>
    </div>
  </div>
</div>
